export const spacingOptions = {
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '16': '16px',
  '20': '20px',
  '24': '24px',
  '28': '28px',
  '32': '32px',
  '40': '40px',
  '48': '48px',
  '64': '64px',
  '80': '80px',
  '96': '96px',
  '128': '128px',
  '160': '160px'
}
